// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__VauN+","text":"Footer_text__pS+zn"};